import {
  logEvent as logEventOriginal,
  setUserId as setUserIdOriginal,
} from 'firebase/analytics'
import { useFirebaseAnal } from './useFirebaseAnal'

export { FirebaseProvider } from './FirebaseProvider'

export const useAnal = () => {
  const analytics = useFirebaseAnal()

  const logEvent = (eventName: string, params?: Record<string, unknown>) => {
    if (!analytics) {
      console.debug('logEvent', eventName, params)
      return
    }
    logEventOriginal(analytics, eventName, params)
  }

  const setUserId = (userId: string) => {
    if (!analytics) {
      console.debug('setUserId', userId)
      return
    }
    setUserIdOriginal(analytics, userId)
  }

  return {
    logEvent,
    setUserId,
  }
}
